import { watch, type WatchSource } from 'vue'

import { lockDocumentScroll } from '@/composables/useDocumentScrollLock'

/**
 * While `isOpen` is true: locks document scroll and listens for Escape on
 * `document`. Callers decide whether to `preventDefault` and what to do in
 * `onEscapeKey` (e.g. UILightbox always closes; UIModal only when click-away
 * close is enabled).
 */
export function watchOpenOverlay(
  isOpen: WatchSource<boolean>,
  onEscapeKey: (event: KeyboardEvent) => void,
): void {
  watch(isOpen, (open, _prev, onCleanup) => {
    if (!open) {
      return
    }
    const releaseScroll = lockDocumentScroll()
    const onKeyDown = (e: Event) => {
      if (!(e instanceof KeyboardEvent) || e.key !== 'Escape') {
        return
      }
      onEscapeKey(e)
    }
    document.addEventListener('keydown', onKeyDown)
    onCleanup(() => {
      releaseScroll()
      document.removeEventListener('keydown', onKeyDown)
    })
  })
}
